import Axios from 'axios'
import orderApi from './order'
// 测试版本
Axios.defaults.baseURL = window.origin
// Axios.defaults.baseURL = 'http://10.20.0.224:30002'
// Axios.defaults.baseURL = 'http://10.20.0.85:30002'
// Axios.defaults.baseURL = 'https://gs.czbanbantong.com'

// cookie 跨域
// Axios.defaults.crossDomain = true
// Axios.defaults.withCredentials = true

const requestCallback = {
  call: config => config,
  error: error => Promise.reject(error)
}
const responseCallback = {
  call: res => res,
  error: error => error.response
}

// 请求前拦截paperHome
Axios.interceptors.request.use(
  config => {
    // config.url = 'ecom/dz' + config.url
    // if (sessionStorage.getItem('token')) {
    //   if (config.url.indexOf('fileApi/fileOperations/upload') === -1) {
    //     config.headers.Authorization = sessionStorage.getItem('token')
    //     // config.headers.menuId = sessionStorage.getItem('menuId') || '1'
    //   }
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 请求后拦截
Axios.interceptors.response.use(
  // response => {
  //   // if (response.data.code == "-99") {
  //   // router.replace({
  //   //   path: "/login",
  //   // });
  //   // }
  //   return response
  // },
  // function (error) {
  //   return Promise.reject(error)
  // }
  res => {
    return responseCallback.call(res)
  },
  error => {
    console.log(error)
    return responseCallback.error(error)
  }
)

export const orderService = orderApi
